import { render, staticRenderFns } from "./ProjectContent.vue?vue&type=template&id=77ba9c14&"
import script from "./ProjectContent.vue?vue&type=script&lang=js&"
export * from "./ProjectContent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports